module.exports = __webpack_public_path__ + "img/16.a6dd5d0f.png";